<template>
  <v-switch
    v-model="boolValue"
    :label="label"
    :disabled="readonly"
    :color="boolValue ? 'green' : 'red'"
  />
</template>

<script setup>
import { computed , ref, watch} from 'vue'
import {useLogger} from "@/composables/useLogger"
const {sendLog} = useLogger() 

defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  modelValue: { type: String, required: true }, // backend string
  label: String,
  readonly: Boolean
})

const emit = defineEmits([
  'update:modelValue',
  'enable',
  'disable'
])

const trueString = computed(() => ['yes','true'].includes(props.modelValue) ? props.modelValue === 'yes' ? 'yes' : 'true' : 'yes')
const falseString = computed(() => trueString.value === 'yes' ? 'no' : 'false')

// internal boolean for v-switch
const boolValue = ref(props.modelValue === trueString.value)

// watch prop changes to update internal state
watch(() => props.modelValue, (val) => {
  boolValue.value = val === trueString.value
})

// watch internal state to emit
watch(boolValue, (val, oldVal) => {
  emit('update:modelValue', val ? trueString.value : falseString.value)

  sendLog("debug", "switch_value", {oldVal, val})
  if (oldVal === true && val ===false) {
    sendLog("info", "background_api_call", {component: "StringSwitch", action: "disable_event_is_fired"})
    emit('disable')
  }

})
</script>